import { useEffect, useState } from "react";
import axios from "axios";
import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Blog from "../../components/home/Blog";
import Chart from "../../components/home/Chart";
import InquiryList from "../../components/home/InquiryList";
import Partners from "../../components/home/Partners";
import Review from "../../components/home/Review";
import Service from "../../components/home/Service";

const Home = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => setData(res.data.data));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Banner />
      <About />
      <Service />
      <Blog data={data} />
      <Chart />
      <Review />
      <InquiryList />
      <Partners />
    </div>
  );
};

export default Home;
